export const isAppointmentInfoQueryEnabled = (appointmentId: string): boolean =>
  appointmentId.length > 0;
